import {
    GET_SEASON_ERROR,
    GET_SEASON_REQUEST,
    GET_SEASON_SUCCESS,
    ADD_SEASON_ERROR,
    ADD_SEASON_REQUEST,
    ADD_SEASON_SUCCESS,
    DELETE_SEASON_REQUEST,
    DELETE_SEASON_SUCCESS,
    DELETE_SEASON_ERROR,
    UPDATE_SEASON_ERROR,
    UPDATE_SEASON_REQUEST,
    UPDATE_SEASON_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");
export const getSeason = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_SEASON_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/season`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_SEASON_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_SEASON_ERROR,
                payload: error.response,
            });
        });
};

export const addSeason = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_SEASON_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/season`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { season_name: data.seasonName, is_active: data.check, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_SEASON_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_SEASON_ERROR,
                payload: error.response,
            });
        });
};
export const updateSeason = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_SEASON_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/season/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { season_name: data.seasonName, is_active: data.check },
    })
        .then((response) => {
            return dispatch({ type: UPDATE_SEASON_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_SEASON_ERROR,
                payload: error.response,
            });
        });
};

export const deleteSeason = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_SEASON_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/season/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_SEASON_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_SEASON_ERROR,
                payload: error.response,
            });
        });
};
